module.exports = __webpack_public_path__ + "img/BACK-PROCESO-ELABORACION-OPACIDAD.d5d07d7b.png";